import styled from "styled-components"
import { Button } from "@theguarantors/ui-kit-v2"
import { colors } from "@theguarantors/ui-kit-v2/dist/design-system/colors"
import { breakpoints } from "@theguarantors/ui-kit-v2/dist/design-system/breakpoints"

const shadowColor = "rgba(67,69,172,0.5)"
interface ButtonProps {
  newGetStartedPageFeatureFlag?: boolean
}

const newCTAStyle = `
    & > span {
      font-size: 1.6rem;
      line-height: 2.6rem;
    }
    border: 1px solid white;
    &:hover {
      background: white;
      color: ${colors.v2_deepNavy};
      border: 1px solid ${colors.v2_deepNavy};
      border-radius: 10px;
    }
    height: 55px;
    min-width: 154px;
    width: 154px;
    padding: 0;
`

export const SubmitButton = styled(Button)<ButtonProps>`
  line-height: 2.6rem;
  width: 27.2rem;

  ${(props: ButtonProps) =>
    props.newGetStartedPageFeatureFlag
      ? newCTAStyle
      : `
    font-size: 2.1rem;
    box-shadow: 0 0.5rem 1rem 0 ${shadowColor};

    &:hover {
      box-shadow: 0 1rem 2rem 0 ${shadowColor};
    }
  `}
`

export const SignInButton = styled(Button)<ButtonProps>`
  height: 55px;
  width: 112px;
  text-align: center;
  padding: 0;

  ${(props: ButtonProps) =>
    props.newGetStartedPageFeatureFlag
      ? newCTAStyle
      : `
    font-size: 2.1rem;
    box-shadow: 0 0.5rem 1rem 0 ${shadowColor};

    &:hover {
      box-shadow: 0 1rem 2rem 0 ${shadowColor};
    }
  `}
`

export const FaqButton = styled(Button)<ButtonProps>`
  @media (max-width: ${breakpoints[1]}) {
    background: #fff;
    color: ${colors.ultramarine};
    border: 3px solid ${colors.ultramarine};
    box-shadow: none;
  }

  ${(props: ButtonProps) => (props.newGetStartedPageFeatureFlag ? newCTAStyle : ``)}
`
